/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';
import { GridColumnJustify } from '@veeam-vspc/shared/components';

import type { GridColumnProps } from '@veeam-vspc/shared/components';
import type { CompanyBackupAgents } from '@veeam-vspc/models/web-controllers';

import { TopsGrid } from '../../../TopsGrid';
import { useCommonSettings } from '../../../../hooks';
import { TopDataUrls } from '../../../../enums';
import { ConfigSectionIds } from 'core/enums';


import type { TopsGridComponentWrapper } from '../../../../interfaces';

export const ManagedBackupAgents: React.FC<TopsGridComponentWrapper> = ({ maxNumberOfRows }) => {
    const settings = useCommonSettings<CompanyBackupAgents>({
        maxNumberOfRows,
        getDataRequestUrl: TopDataUrls.ManagedBackupAgents,
    });
    const { lang } = settings;

    const columns: GridColumnProps<CompanyBackupAgents>[] = [
        {
            id: 'companyName',
            title: lang.COMPANY,
            cell: rowData => rowData.companyName,
        },
        {
            id: 'siteName',
            title: lang.SITE,
            cell: rowData => rowData.siteName,
        },
        {
            id: 'endpointsCount',
            title: lang.BACKUP_AGENTS,
            cell: rowData => rowData.endpointsCount,
            justify: GridColumnJustify.Right,
        },
    ];

    return (
        <TopsGrid
            title={lang.TOP_COMPANIES_BY_MANAGED_BACKUP_AGENTS}
            columns={columns}
            sectionId={ConfigSectionIds.TopsCompanies}
            maxNumberOfRows={maxNumberOfRows}
            {...settings}
        />
    );
};
